import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import QuickStart from "./components/QuickStart";
import InstallGuide from "./components/InstallGuide";
import VersionUpdates from "./components/VersionUpdates";
import Community from "./components/Community";
import Faq from "./components/Faq";
import Requirements from "./components/Requirements";
import Reviews from "./components/Reviews";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <QuickStart />
        <InstallGuide />
        <VersionUpdates />
        <Community />
        <Faq />
        <Requirements />
        <Reviews />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}